import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ConfirmDialog from "../../components/dialog/ConfirmDialog";
import { useState } from "react";
import { BsCheckCircleFill } from "react-icons/bs";
import { FaDownload } from "react-icons/fa";
import { Button } from "primereact/button";

function TableSystemAlerts({
    alerts,
    reloadTable = () => { },
    markAsResolved = () => { }
}) {
    const [viewConfirmDialog, setViewConfirmDialog] = useState(false);
    const [selectedAlert, setSelectedAlert] = useState(null);

    const downloadJsonError = (row) => {
        const json = JSON.stringify(row.metadata, null, 2);

        const blob = new Blob([json], { type: "application/json" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `${row.name}.json`;
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    return (
        <>
            <div className="card p-0" aria-label="table"
                style={{
                    borderRadius: "12px",
                    overflow: "hidden",
                }}
            >
                <DataTable
                    value={alerts}
                    dataKey="id"
                    paginator
                    rows={10}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    filterDisplay="row"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                    filter
                    responsiveLayout="scroll"
                >
                    <Column
                        field="bot_id"
                        header={"Chatbot ID"}
                        filter
                        filterMatchMode={["contains"]}
                        showFilterMenu={false}
                        body={(rowData) => (rowData.bot_id || "- Sin ID -")}
                    />
                    <Column
                        field="bot_name"
                        header={"Nombre"}
                        filter
                        filterMatchMode={["contains"]}
                        showFilterMenu={false}
                        body={(rowData) => (rowData.bot_name || "- Sin nombre -")}
                    />
                    <Column
                        field="description"
                        header={"Alertas del sistema"}
                        filter
                        filterMatchMode={["contains"]}
                        showFilterMenu={false}
                        body={(rowData) => (
                            <div className="d-flex flex-column gap-1">
                                <span>{rowData.name}</span>
                                <small className="text-muted">{rowData.description || "- Sin descripción -"}</small>
                            </div>
                        )}
                    />
                    <Column
                        field="created_date.timestamp"
                        header={"Fecha de creación"}
                        showFilterMenu={false}
                        sortable
                        body={(rowData) => (
                            <div className="d-flex flex-column gap-1">
                                <div>
                                    <span className="entity-values-badge">{rowData.created_date.relative}</span>
                                </div>
                                <small className="text-muted">{rowData.created_date.date + " - " + rowData.created_date.time + "hs" || "- Sin fecha -"}</small>
                            </div>
                        )}
                    />
                    <Column
                        field="updated_date.timestamp"
                        header={"Última actualización"}
                        showFilterMenu={false}
                        sortable
                        body={(rowData) => (
                            <div className="d-flex flex-column gap-1">
                                <div>
                                    <span className="entity-values-badge">{rowData.updated_date.relative}</span>
                                </div>
                                <small className="text-muted">{rowData.updated_date.date + " - " + rowData.updated_date.time + "hs" || "- Sin fecha -"}</small>
                            </div>
                        )}
                    />
                    <Column
                        field="state"
                        header="Estado"
                        body={(rowData) => {
                            const isResolved = rowData.state === "resolved";
                            const stateLabels = { resolved: "Resuelta", critical: "Crítica", warning: "Advertencia" };
                            const config = isResolved
                                ? { label: "Resuelta", bg: "#dcfce7", border: "#86efac", color: "#15803d" }
                                : { label: stateLabels[rowData.state] ?? rowData.state ?? "Sin estado", bg: "#fee2e2", border: "#fca5a5", color: "#b91c1c" };

                            return (
                                <div className="d-inline-flex align-items-center gap-2">
                                    <span
                                        className="entity-values-badge"
                                        style={{
                                            backgroundColor: config.bg,
                                            borderColor: config.border,
                                            color: config.color,
                                        }}
                                    >
                                        {config.label}
                                    </span>
                                    {!isResolved && (
                                        <div
                                            title="Marcar como resuelta"
                                            onClick={() => { setSelectedAlert(rowData); setViewConfirmDialog(true); }}
                                            style={{
                                                cursor: "pointer",
                                                width: 24,
                                                height: 24,
                                                borderRadius: "50%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                backgroundColor: "#ffffff",
                                                border: "1px solid #cbd5e1",
                                                color: "#64748b",
                                                transition: "all .2s ease",
                                            }}
                                        >
                                            <BsCheckCircleFill size={14} />
                                        </div>
                                    )}
                                </div>
                            );
                        }}
                    />

                    <Column
                        className={"actionheader p-2"}
                        exportable={false}
                        body={(row) => (
                            <Button
                                type="button"
                                icon={<FaDownload size={"0.9rem"} />}
                                className="action-body-btn action-body-btn-aqua"
                                tooltip="Descargar JSON"
                                tooltipOptions={{ position: "top" }}
                                onClick={() => downloadJsonError(row)}
                                aria-label="descargar"
                            />
                        )}
                        style={{ width: "6rem", textAlign: "center" }}
                    ></Column>
                </DataTable>
            </div>

            <ConfirmDialog
                visible={viewConfirmDialog}
                title="Marcar como resuelta"
                onClose={() => {
                    setViewConfirmDialog(false);
                }}
                icon={<BsCheckCircleFill size={40} />}
                iconBackgroundColor="green"
                confirmColor="success"
                onConfirm={async () => {
                    await markAsResolved(selectedAlert);
                    setSelectedAlert(null);
                    setViewConfirmDialog(false);
                }}
                description="¿Estás seguro que quieres marcar la alerta del sistema como resuelta?"
            />
        </>
    );
}

export default TableSystemAlerts;
